const DEV = false;

const globals = {
    WS: "https://districentro.openplus.net.ar/api",
    OPEN: "https://districentro.openplus.net.ar",
    CDN: [],
    enContruccion: false,
    soloCatalogo: false,
    whatsapp: '+5491122608188',
    whatsappLindo: '+54 911 2260-8188',
    anchoCarrito: '75vw'
};
for(var c = 1; c <= 5; c++) {
    globals.CDN.push("https://cdn" + c + "-districentro.openplus.net.ar");
}

if (DEV) {
    globals.WS = "http://localhost:4000/api";
    globals.OPEN = "http://localhost:4000";
}

export { globals as default };
